import Register from "./components/Register";
import ipConfig from "./ipConfig.json";
import { Route, Switch } from "react-router-dom";
import Login from "./components/Login";
import Products from "./components/Products";
import Checkout from "./components/Checkout";
import Thanks from "./components/Thanks";

export const config = {
  endpoint: `https://qkartt-frontend.herokuapp.com/api/v1`,
};
// export const config = {
//   endpoint: `http://${ipConfig.workspaceIp}:8082/api/v1`,
// };

function App() {
  return (
    <div className="App">
     <Switch>
     <Route exact path="/">
       <Products />
       </Route>
     <Route path="/Register">
        <Register />
     </Route>
     <Route path="/Login">
       <Login />
     </Route>
     <Route path="/checkout">
       <Checkout />
     </Route>
     <Route path="/thanks">
       <Thanks />
     </Route>

     </Switch>
     </div>
   );
}

export default App;